module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/7PKrYB/tc-custom/9781446360286.jpg?1694191843879",
      "alt": "This image is the cover for the book Easy Buttercream Cake Designs"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Easy Buttercream Cake Designs\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Top off your cake with a sweet work of art!")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Do you dream of being able to make beautiful decorated cakes for any occasion? "), _c('i', [_vm._v("Easy Buttercream Cake Designs")]), _vm._v(" will teach you the essential buttercream cake decorating techniques you need to know to create your own amazing designs."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Also included are three gorgeous pastel-colored cake projects, piped with buttercream, that are impressive and stylish—in addition to being completely delicious.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Fiona Pearce\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    David & Charles\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0